import { observer } from "mobx-react";
import useStore from "../../../store";
import { useEffect } from "react";
import PageHeader from '../../../component/PageHeader';
import { Button, Form, Input } from 'antd';
import ListComponent from "./Component/ListComponent";
import { EnquiryBreadcrumb } from "../../../config/BreadcrumbConfig";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from 'react';
import AddComponent from './components/AddComponent';
import DeleteComponent from './components/DeleteComponent';
import EditComponent from './components/EditComponent';

const Enquiry = observer(() => {
	const [enquiryAddModal, setEnquiryAddModal] = useState(false);
	const [enquiryEditModal, setEnquiryEditModal] = useState(false);
	const [enquiryDeleteModal, setEnquiryDeleteModal] = useState(false);
	const { ENQUIRY,TOURPACKAGECATEGORY} = useStore();
	const { AUTH } = useStore();

	const AddEnquiryModal = () => {
		setEnquiryAddModal(true);
		AUTH.getAllByLookupKeyList(`lookupKey=EnquiryType&isAdmin=false`);
	};
	const closeAddModal = () => {
		setEnquiryAddModal(false);
	};

    const openEdit = () => {
		setEnquiryEditModal(true);
		AUTH.getAllByLookupKeyList(`lookupKey=EnquiryType&isAdmin=false`);
	};

	const closeEditModal = () => {
		setEnquiryEditModal(false);
	};

	const openDelete = (data) => {
		setEnquiryDeleteModal(data);
	};

	const closeDeleteModal = () => {
		setEnquiryDeleteModal(false);
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			ENQUIRY.searchValue = text;
			ENQUIRY.setupGrid(ENQUIRY.agGrid);
		}
	};

	useEffect(() => {
		return () => {
			ENQUIRY.searchValue = '';
		};
	}, []);
	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={EnquiryBreadcrumb.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<a
						key="export"
						id="export-download-link"
						style={{ textDecoration: 'none' }}
						target="_blank"
						download={'Enquiry-record.xlsx'}
					>
						<Button
							key={2}
							type="primary"
							icon={<FontAwesomeIcon icon={faDownload} />}
							onClick={() => ENQUIRY.exportEnquiry()}
							title={'Download Excel File'}
							className="addBtn"
						>
							Download Enquiry Report
						</Button>,
						<Button
							type="primary"
							onClick={AddEnquiryModal}
							title={'Add Enquiry'}
							key={3}
						>
							Add Enquiry
						</Button>
					</a>,
				]}
			/>
			<ListComponent openEditModal={openEdit} openDeleteModal={openDelete} />
			<AddComponent visible={enquiryAddModal} onClose={closeAddModal}/>
			<EditComponent visible={enquiryEditModal} onClose={closeEditModal} />
			<DeleteComponent visible={enquiryDeleteModal} onClose={closeDeleteModal}
						/>
		</div>
	);
});

export default Enquiry;